export const JointsWidget = {
  JointsTable: "jointsTable",
  HeightProfileChart: "heightProfileChart",
  Histogram: "histogram",
  GradientLegend: "gradientLegend",
  ColorsLegend: "colorsLegend",
  WMSWidget: "wmsWidget",
  WMSLegend: "wmsLegend",
};
